import type {
  NewsDetailedSerializer,
  PromoDetailedSerializer,
  CmsLandingDetailedSerializer,
  AboutCompanyDetailedSerializer,
  OkResponse_NewsDetailedSerializer_,
  OkResponse_PromoDetailedSerializer_,
  OkResponse_CmsLandingDetailedSerializer_,
  OkResponse_AboutCompanyDetailedSerializer_,
  PaginationResponse_NewsListSerializer_,
  PaginationResponse_PromoListSerializer_,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";

type CmsListResponse =
  | PaginationResponse_NewsListSerializer_
  | PaginationResponse_PromoListSerializer_;

type CmsEntity =
  | NewsDetailedSerializer
  | PromoDetailedSerializer
  | CmsLandingDetailedSerializer
  | AboutCompanyDetailedSerializer;

type CmsEntityResponse =
  | OkResponse_NewsDetailedSerializer_
  | OkResponse_PromoDetailedSerializer_
  | OkResponse_CmsLandingDetailedSerializer_
  | OkResponse_AboutCompanyDetailedSerializer_;

interface ICmsEntityListRequestParams {
  entity: "news" | "promo";
  limit: number;
  before?: string;
  after?: string;
}

interface ICmsEntityRequestParams {
  entity: "news" | "promo" | "cms-landings" | "about-company";
  idOrSlug: string | number;
}

export const cmsApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getCmsEntityList: build.query<CmsListResponse, ICmsEntityListRequestParams>(
      {
        query: ({ entity, ...params }) => ({
          url: `/foundation/api/${entity}`,
          params,
        }),
        serializeQueryArgs: ({ endpointName, queryArgs }) => {
          return `${endpointName}_${queryArgs.entity}_${queryArgs.limit}`;
        },
        merge: (currentCacheData, responseData) => {
          currentCacheData.payload.pagination = responseData.payload.pagination;
          currentCacheData.payload.data.push(...responseData.payload.data);
        },
        forceRefetch({ currentArg, previousArg }) {
          return currentArg?.after !== previousArg?.after;
        },
      }
    ),
    getCmsEntity: build.query<CmsEntity, ICmsEntityRequestParams>({
      query: ({ entity, idOrSlug }) => ({
        url: `/foundation/api/${entity}/${idOrSlug}`,
      }),
      transformResponse: (response: CmsEntityResponse) => {
        const content = response.payload.data.content
          .replaceAll(/(\[cdata\]|\[\/cdata\])/g, "")
          .trim();
        return {
          ...response.payload.data,
          content,
        };
      },
    }),
  }),
});
